import { useQueryParam } from './useQueryParam';

export const useQueryExist = (key: string): boolean => {
  const result = useQueryParam(key);

  return result !== null;
};
